import React from 'react';
import { Box } from '@material-ui/core';
import { btLightOrange, hexToRgb, secondaryLightBlue, welcomeBlue, whiteColor } from '../../../assets/jss/nextjs-material-kit-pro';
import { makeStyles } from '@material-ui/core/styles';

const useStyledBoxStyles = makeStyles({
  boxStar: {
    display: 'inline-block',
    width: '33px',
    height: '100%',
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
    backgroundColor: 'white',
    zIndex: 0,
    position: 'relative',
    '&.completed': {
      backgroundColor: btLightOrange,
    },
  },
  boxTrophy: {
    marginLeft: '-17px',
    marginTop: '-10px',
    width: '80px',
    height: '70px',
    position: 'relative',
    zIndex: 200,
    background: 'none',
    pointerEvents: 'none',
  },
});

export const StyledBoxStar = React.forwardRef(({ completed, ...props }, ref) => {
  const classes = useStyledBoxStyles();
  return (
    <Box
      ref={ref}
      className={`${classes.boxStar} ${completed ? 'completed' : ''}`}
      {...props}
    />
  );
});

export const StyledBoxTrophy = React.forwardRef((props, ref) => {
  const classes = useStyledBoxStyles();
  return <Box ref={ref} className={classes.boxTrophy} {...props} />;
});

export const useWorkbookModuleStyles = makeStyles((theme) => ({
  displayStars: {
    position: 'relative',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: whiteColor,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  imageHeader: {
    overflow: 'hidden',
    background: secondaryLightBlue,
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      height: '310px',
      paddingTop: '-20px',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  homeIcon: {
    fontSize: '1.813rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    color: welcomeBlue,
    transform: 'rotateZ(180deg)',
    marginTop: '20px',
    [theme.breakpoints.up('md')]: {
      marginBottom: 20,
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 40,
      marginTop: '40px',
    },
  },
  completionText: {
    fontWeight: 700,
    color: whiteColor,
    textAlign: 'left',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 200,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.875rem',
      lineHeight: '2.35rem',
      textAlign: 'left',
      paddingLeft: '10px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.375rem',
      lineHeight: '1.55rem',
      textAlign: 'left',
      paddingLeft: '20px',
    },
  },
  workbookModuleStars: {
    backgroundColor: 'rgba(' + hexToRgb(welcomeBlue) + ', 0.40)',
    position: 'absolute',
    left: 0,
    [theme.breakpoints.up('md')]: {
      bottom: 0,
      width: '105%',
      padding: '35px 0 30px 0',
    },
    [theme.breakpoints.down('md')]: {
      bottom: 0,
      width: '120%',
      padding: '35px 0 20px 0',
    },
    [theme.breakpoints.down('sm')]: {
      bottom: '55px',
      width: '120%',
      padding: '15px 0 15px 0',
    },
  },
  moveToFront: {
    height: '100%',
    border: '2px solid green',
    position: 'relative',
    zIndex: 200,
  },
  completionSection: {
    display: 'flex',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  lineStyle: {
    borderTop: '0.00225rem dashed white',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    [theme.breakpoints.down('sm')]: {
      margin: '0 0 10px 0',
      width: '95%',
    },
    [theme.breakpoints.up('md')]: {
      margin: '-5px 0 10px 0',
      width: '94%',
    },
  },
  setReturnButtonFrameSize: {
    [theme.breakpoints.down('sm')]: {
      width: '110%',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
}));
